import { Pipe, PipeTransform } from '@angular/core';
import Permission from './../permissions.json';

@Pipe({ name: 'permit' })
export class Permit implements PipeTransform {
    transform(value: string): string {
        return Permission[value];
    }
}